import * as React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Modal, Button, Spin, Col, Row, Menu, Dropdown, Input } from 'antd'
import { inject, observer } from 'mobx-react'
import styles from './index.scss'
import { levelStrategies } from 'store/LevelStore'
import { throttle } from 'lodash'
import { templateType } from 'constants/index'

const ButtonGroup = Button.Group
const confirm = Modal.confirm
const TextArea = Input.TextArea
let editFavoriteConfirm

interface IFavoritesModalProps {
  levelStore?: any
  lessons: any[]
  togglePreviewModal?: (visible: boolean, type: string, id?) => void
  checkActiveLessonID?: number | string
  exportFavoritesTemplate: (param) => void
}

interface IFavoritesModalState {
  showRoleOperation: boolean
  showStaffOperation: boolean
  checkRoles: any[]
  checkRolesMeta: any
  loading: boolean
  hasMore: boolean
  filter: any
  activeLesson: any
  activeRole: any
  templateName: string
  updateExplain: string
  currentTemplate: null
  initLesson: null
}

@inject('globalStore', 'levelStore')
@observer
export default class FavoritesModal extends ComponentExt<
  IFavoritesModalProps,
  IFavoritesModalState
> {
  state = {
    templateName: '',
    updateExplain: '',
    currentTemplate: null,
    showRoleOperation: false,
    showStaffOperation: false,
    checkRoles: [],
    checkRolesMeta: null,
    loading: false,
    hasMore: true,
    activeLesson: { id: 0, name: '' },
    activeRole: null,
    filter: {
      page: 1,
      with_detail: true,
    },
    initLesson: null,
  }

  favoritesScroll = throttle(async evt => {
    const isBottom =
      evt && evt.target
        ? evt.target.scrollHeight -
            (evt.target.scrollTop + evt.target.clientHeight) <=
          10
        : false

    const {
      levelStore: {
        favoritesTemplate,
        favoritesTemplateMeta: {
          pagination: { total, current_page },
        },
      },
    } = this.props
    const { activeLesson } = this.state

    if (!isBottom) {
      return false
    }

    if (isBottom && total > favoritesTemplate.length) {
      this.setState(
        {
          filter: {
            ...this.state.filter,
            lesson_id: activeLesson.id,
            page: current_page + 1,
          },
        },
        () => this.getFavoritesList('append'),
      )
    }
  }, 300)

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      checkActiveLessonID,
      lessons,
      levelStore: { favoritesVisible },
    } = nextProps
    // 判断第一次进入当前页面
    if (
      favoritesVisible &&
      favoritesVisible !== prevState.prevFavoritesVisible
    ) {
      return {
        initLesson: lessons.find(lesson => lesson.id === checkActiveLessonID),
        activeLesson: lessons.find(lesson => lesson.id === checkActiveLessonID),
        prevFavoritesVisible: favoritesVisible,
        filter: {
          ...prevState.filter,
          lesson_id: lessons[0].id,
        },
      }
    } else if (!favoritesVisible) {
      return {
        activeLesson: { id: 0, name: '' },
        prevFavoritesVisible: false,
      }
    }

    return null
  }

  async componentDidMount() {}

  toggleTableLoading = () => this.setState({ loading: !this.state.loading })

  getFavoritesList = async (mode = 'add'): Promise<any> => {
    const {
      levelStore: { getEntityList },
    } = this.props
    this.toggleTableLoading()
    await getEntityList(
      levelStrategies.FAVORITES_TEMPLATE,
      this.state.filter,
      mode,
    )
    this.toggleTableLoading()
  }

  switchLesson = async (lesson): Promise<any> => {
    this.setState(
      {
        activeLesson: lesson,
        filter: {
          ...this.state.filter,
          lesson_id: lesson.id,
          page: 1,
        },
      },
      () => this.getFavoritesList(),
    )
  }

  togglePreview = template => {
    this.props.togglePreviewModal(true, templateType.unit, template.id)
  }

  updateFavoriteTemplate = template => {
    this.setState(
      {
        currentTemplate: template,
        templateName: template.name,
        updateExplain: template.update_explain,
      },
      () => {
        editFavoriteConfirm = confirm({
          title: '编辑收藏关卡',
          content: this.renderEditContent(template),
          onOk: async () => {
            const {
              levelStore: { updateEntity },
              levelStore,
            } = this.props
            levelStore.changeHook(false)
            await updateEntity(
              levelStrategies.FAVORITES_TEMPLATE,
              template.id,
              {
                name: this.state.templateName,
                update_explain: this.state.updateExplain,
              },
              {
                param: {
                  ...this.state.filter,
                },
              },
            )
            levelStore.changeHook(true)

            this.$message.success('收藏关卡更新成功')
            this.getFavoritesList('add')
          },
        })
      },
    )
  }

  renderEditContent = template => {
    return (
      <div key={template.id}>
        <Row type="flex" align="middle">
          <Col span={6}>通关名称：</Col>
          <Col span={18}>
            <Input
              value={this.state.templateName}
              placeholder={'请为关卡起一个名称'}
              onChange={this.inputTemplateName}
            />
          </Col>
        </Row>
        <Row>
          <Col span={6} style={{ marginTop: 10 }}>
            关卡说明：
          </Col>
          <Col span={18} style={{ marginTop: 10 }}>
            <div>
              <TextArea
                value={this.state.updateExplain}
                placeholder={'请输入关卡说明'}
                rows={4}
                onChange={this.inputUpdateExplain}
              />
            </div>
          </Col>
        </Row>
      </div>
    )
  }

  inputTemplateName = e =>
    this.setState({ templateName: e.target.value }, () =>
      editFavoriteConfirm.update({
        content: this.renderEditContent(this.state.currentTemplate),
      }),
    )

  inputUpdateExplain = e =>
    this.setState({ updateExplain: e.target.value }, () =>
      editFavoriteConfirm.update({
        content: this.renderEditContent(this.state.currentTemplate),
      }),
    )

  exportFavoritesTemplate = template => {
    const {
      exportFavoritesTemplate,
      levelStore: { setCurrentCheck },
    } = this.props
    const param = {
      id: template.id,
      check_per_page: 1000,
    }

    confirm({
      title: '导出收藏关卡操作',
      content:
        '导入收藏关卡将会清空现有设置，如有必要先将当前版本保存为操作再执行导出操作',
      onOk: async () => {
        setCurrentCheck(null)
        await exportFavoritesTemplate(param)
        this.$message.success('导出收藏关卡成功')
      },
    })
  }

  deleteFavoriteTemplate = template => {
    confirm({
      title: '删除收藏关卡操作',
      content: '请确认是否删除收藏的关卡？',
      onOk: async () => {
        const {
          levelStore: { removeEntity },
        } = this.props
        await removeEntity(levelStrategies.FAVORITES_TEMPLATE, template.id)
        this.getFavoritesList('add')
        this.$message.success('删除收藏关卡成功')
      },
    })
  }

  renderMoreMenu = template => {
    const menu = [
      {
        icon: 'edit',
        text: '编辑',
        action: this.updateFavoriteTemplate.bind(this, template),
      },
      {
        icon: 'export',
        text: '导出编辑',
        action: this.exportFavoritesTemplate.bind(this, template),
      },
      // {
      //   icon: 'share',
      //   text: '分享模板',
      //   action: null
      // },
      {
        icon: 'delete',
        text: '删除模板',
        action: this.deleteFavoriteTemplate.bind(this, template),
      },
    ]

    return (
      <Menu>
        {menu.map(m => (
          <Menu.Item key={m.text}>
            <p onClick={m.action}>
              <span
                className={`${styles.operationBtn} ${styles[m.icon + 'Btn']}`}
              />
              <span>{m.text}</span>
            </p>
          </Menu.Item>
        ))}
      </Menu>
    )
  }

  render() {
    const {
      levelStore: {
        favoritesVisible,
        toggleFavoritesModal,
        favoritesTemplate,
        getEntityList,
      },
      lessons,
    } = this.props
    const { activeLesson } = this.state

    const ModalTitle = () => (
      <div>
        <span>已收藏通关模板</span>
        <ButtonGroup>
          {lessons &&
            lessons.map(lesson => (
              <Button
                type={lesson.id === activeLesson.id ? 'primary' : 'default'}
                key={lesson.id}
                onClick={this.switchLesson.bind(this, lesson)}
              >
                {lesson.name}
              </Button>
            ))}
        </ButtonGroup>
      </div>
    )

    return (
      <Modal
        wrapClassName={styles.favoritesModal}
        width={800}
        closable={false}
        footer={
          <Button
            type={'primary'}
            onClick={() => {
              toggleFavoritesModal()
              getEntityList(levelStrategies.FAVORITES_TEMPLATE, {
                lesson_id: this.state.initLesson.id,
              })
            }}
          >
            关闭
          </Button>
        }
        title={<ModalTitle />}
        visible={favoritesVisible}
      >
        <div>
          <ul className={styles.favoritesList} onScroll={this.favoritesScroll}>
            {favoritesTemplate.map(item => (
              <li key={item.id}>
                <Row>
                  <Col>
                    <h3 className={styles.favoritesItemTitle}>
                      <span>名称：{item.name}</span>
                    </h3>
                  </Col>
                </Row>
                <Row style={{ borderBottom: '1px solid #EEE' }}>
                  <Col span={20} className={styles.favoritesItemDesc}>
                    <p>
                      <span>
                        创建人：{item.staff && item.staff.staff_name}&nbsp;
                      </span>
                      <span>
                        适用角色：{item.check_role && item.check_role.name}
                        &nbsp;
                      </span>
                      <span>更新日期：{item.updated_at}</span>
                    </p>
                    <p> 关卡说明：{item.update_explain}</p>
                  </Col>
                  <Col>
                    <i
                      className={`${styles.previewBtn} ${styles.operationBtn}`}
                      onClick={this.togglePreview.bind(this, item)}
                    />
                    <Dropdown
                      trigger={['click']}
                      overlay={this.renderMoreMenu(item)}
                    >
                      <i
                        className={`${styles.moreBtn} ${styles.operationBtn}`}
                      />
                    </Dropdown>
                  </Col>
                </Row>
              </li>
            ))}

            {this.state.loading && (
              <div
                className="demo-loading-container"
                style={{ textAlign: 'center' }}
              >
                <Spin />
              </div>
            )}
          </ul>
        </div>
      </Modal>
    )
  }
}
